<template>
  <div
    data-qa="agreement_info"
    class="text-body-2 text-info--text text-center"
  >
    Оплачивая, вы соглашаетесь
    с&nbsp;<a
      data-qa="agreement_info_offer_link"
      href="/static/_v1/pd/documents/pdf/club/Правила_использования_опционов.pdf"
      rel="noopener noreferrer"
      target="_blank"
      class="text-info--text link-decoration-underline"
    >офертой</a>
    <br v-if="isMobile">
    и&nbsp;<a
      data-qa="agreement_info_club_rules_link"
      href="/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе.pdf"
      rel="noopener noreferrer"
      target="_blank"
      class="text-info--text link-decoration-underline"
    >правилами клуба</a>
  </div>
</template>

<script lang="ts" setup>
const isMobile = window.MOBILE_VERSION
</script>
